import { __ } from '@wordpress/i18n';
import { useEffect, useState} from 'react';
import {  store as blockEditorStore} from '@wordpress/block-editor';
import { useSelect ,useDispatch} from '@wordpress/data';
import { DropdownMenu ,  __experimentalText as Text,__experimentalSpacer as Spacer, __experimentalVStack as VStack} from '@wordpress/components';
import { VayuBlocksBlockEditor } from '@vayu-blocks/global';
import {HeightControl} from '@vayu-blocks';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import {alignNone ,stretchWide ,stretchFullWidth, trendingUp} from '@wordpress/icons';
import { CgMenuBoxed } from "react-icons/cg";

// "size":{
//   "type":"object",
//   "default":{
//     "default":{"width":{"Desktop":{},"Tablet":{},"Mobile":{}}, "height":{"Desktop":{},"Tablet":{},"Mobile":{}},
//     "wideWidth":{width:{Desktop:{},Tablet:{},Mobile:{}}, height:{Desktop:{},Tablet:{},Mobile:{}},
//     "fullWidth":{width:{Desktop:{},Tablet:{},Mobile:{}}, height:{Desktop:{},Tablet:{},Mobile:{}},
//     "boxed" : {width:{Desktop:{},Tablet:{},Mobile:{}}, height:{Desktop:{},Tablet:{},Mobile:{}},
//     "type":"default"
//   }
// }

export const VayuBlocksSizeController = ({ size, onChange ,clientId , boxed=true}) => {
	const getView = VayuBlocksDevice(); 

	const [firstTablet, setFirstTablet] = useState(false);
	const [firstDesktop, setFirstDesktop] = useState(true);

   	const blockEditor = VayuBlocksBlockEditor();
	const { updateBlockAttributes } = useDispatch(blockEditorStore);

	const currentType = size?.value?.type || 'default';
	const currentWidth = size?.value?.[currentType]?.width?.[getView];
	const currentHeight = size?.value?.[currentType]?.height?.[getView];

	const contentSize = blockEditor?.__experimentalFeatures?.layout.contentSize || '800px';
	const wideSize = blockEditor?.__experimentalFeatures?.layout.wideSize || '1200px';
	const fullSize = '2000px'; 
	const boxedSize = '2000px'; 

	const {  selectedAlign } = useSelect((select) => {
		const block = select(blockEditorStore).getBlock(clientId);
		return {
			selectedAlign: block?.attributes?.align || '',
		};
	}, [clientId]);

	useEffect(() => {
        const newType = selectedAlign === 'wide' ? 'wide' : selectedAlign === 'full' ? 'full' : 'default';

        if (size?.value?.type !== newType) {
            const updatedSize = {
                ...size?.value,
                type: newType,
            };
            onChange(size?.key, updatedSize);
        }
    }, [selectedAlign]);

	const handleWidthChange = (value) => {
		const updatedSize = {
			...size?.value,
			type: value,
		};
		onChange(size?.key, updatedSize);

		if (clientId) {
			let newAlign = '';
			if (value === 'wide') newAlign = 'wide';
			else if (value === 'full') newAlign = 'full';
			else newAlign = '';

			updateBlockAttributes(clientId, { align: newAlign });
		}

	};

	const handleHeightWidthChange = (dimensionKey, newValue) => {
		const currentType = size?.value?.type || 'default';

		const attr = size.key;

      	const updatedAttributes = {
			...size?.value,
			[currentType]: {
				...size?.value?.[currentType],
				[dimensionKey]: {
					...size?.value?.[currentType]?.[dimensionKey],
					[getView]: newValue,
				},
			},
		};

		const isFirstRun = attr?.[getView] === undefined;
		const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

		if (getView === 'Desktop') {
			if (isFirstRun || firstDesktop) {
				Object.assign(updatedAttributes[currentType][dimensionKey], { Tablet: newValue, Mobile: newValue });
				localStorage.setItem('firstTablet', 'true');
				setFirstTablet(true);
				setFirstDesktop(true);
			}
			} else if (getView === 'Tablet') {
			if (isTabletFirstRun) {
				Object.assign(updatedAttributes[currentType][dimensionKey], { Mobile: newValue});
				localStorage.removeItem('firstTablet');
				setFirstTablet(true);
				setFirstDesktop(false);
			}
			} else {
			setFirstTablet(false);
			setFirstDesktop(false);
		}
		
		onChange(size?.key, updatedAttributes);
	};

	const controls = [
		{
			title: (
				<div style={{ display: 'flex', flexDirection: 'column' ,alignItems: 'baseline',justifyContent: 'center',marginLeft: '5px'}}>
				  <span>{__('Default', 'vayu-blocks')}</span>
				  <span style={{ fontSize: '12px', color: '#666' }}>
					Max {contentSize} wide
				  </span>
				</div>
			  ),
			icon: alignNone,
			isActive: currentType === 'default',
			onClick: () => handleWidthChange('default'),
		},
		{
			title: (
				<div style={{ display: 'flex', flexDirection: 'column' ,alignItems: 'baseline',justifyContent: 'center',marginLeft: '5px'}}>
				  <span>{__('Wide Width', 'vayu-blocks')}</span>
				  <span style={{ fontSize: '12px', color: '#666' }}>
					Max {wideSize} wide
				  </span>
				</div>
			  ),
			icon: stretchWide,
			isActive: currentType === 'wide',
			onClick: () => handleWidthChange('wide'),
		},
		{
			title: 'Full Width',
			icon: stretchFullWidth,
			isActive: currentType === 'full',
			onClick: () => handleWidthChange('full'),
		},
		...(boxed ? [
			{
				title: 'Boxed',
				icon: <CgMenuBoxed />,
				isActive: currentType === 'boxed',
				onClick: () => handleWidthChange('boxed'),
			}
		] : []),
	];

	const getMaxSize = (type) => {
		switch (type) {
			case 'wide':
				return parseFloat(wideSize);
			case 'full':
				return parseFloat(fullSize);
			case 'boxed':
				return parseFloat(boxedSize);
			default:
				return parseFloat(contentSize);
		}
	};

	const iconMap = {
		default: alignNone,
		wide: stretchWide,
		full: stretchFullWidth,
		boxed: <CgMenuBoxed />,
	};

	const currentIcon = iconMap[currentType] || alignNone;

	return (
	
		<VStack>

			<Text>
				<div >     
					<label><VayuBlocksDeviceControl label={__('Content Width', 'vayu-blocks')} classname='bold' /></label>

					<DropdownMenu
						icon={
							<span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
								{currentIcon}
								<span>{currentType}</span>
							</span>
						}
						label= {__('Content Width','vayu-blocks')}
						popoverProps={{ className: 'vb-dropdown-popover-props', focusOnMount: true ,__experimentalShowBackdrop: true, }}
						controls={controls}
						className = "vb-drop-down-content"
					/>

				</div>
			</Text>

			<Spacer />

		{(currentType === 'full' || currentType === 'boxed') && (
			<>
				<Text>
					<HeightControl 
						label={__('Width','vayu-blocks')}
						onChange={(val) => handleHeightWidthChange('width', val)}
						value={currentWidth}
						unitMax={{
							px: { max: getMaxSize(currentType), step: 1 },
						}}
					/>
				</Text>

				<Spacer />

				<Text>
					<HeightControl 
						label={__('Height','vayu-blocks')}
						onChange={(val) => handleHeightWidthChange('height', val)}
						value={currentHeight}
					/>
				</Text>
			</>
		)}

		</VStack>

	);
};




{/* <VayuBlocksSizeController 
	size={{key:'size', value:attributes.size}}
	onChange={(key,value)=>setAttributes({[key]:value})}
	clientId = {clientId}
	boxed={false}
/> */}